import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function ModuleStatus() {
  return <V20Embed view="modules" testid="modules-view" />;
}
